import { cn, cva } from 'noddi-ui-common';

// Fills are the EU tire label's own grade colors, so the hue is data, not a theme token.
const gradeBadgeVariants = cva('inline-flex shrink-0 items-center justify-center font-bold', {
  variants: {
    grade: {
      A: 'bg-[#0f9b4a] text-white',
      B: 'bg-[#7bc043] text-black',
      C: 'bg-[#fcdc1a] text-black',
      D: 'bg-[#f6921e] text-black',
      E: 'bg-[#e0211b] text-white',
      F: 'bg-[#e0211b] text-white',
      G: 'bg-[#e0211b] text-white',
      unknown: 'bg-muted text-foreground'
    },
    size: {
      small: 'size-4 rounded-xs text-[10px]',
      medium: 'size-5 rounded-sm text-xs'
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

const GRADES = ['A', 'B', 'C', 'D', 'E', 'F', 'G'] as const;

type Props = {
  /** Wet grip or rolling resistance class, e.g. `A`. */
  grade: string;
  size?: 'small' | 'medium';
  className?: string;
};

/** One EU tire label class as a colored letter tile. */
export const TireEuGradeBadge = ({ grade, size, className }: Props) => {
  const letter = grade.charAt(0).toUpperCase();
  const knownGrade = GRADES.find((value) => value === letter) ?? 'unknown';
  return <span className={cn(gradeBadgeVariants({ grade: knownGrade, size }), className)}>{letter}</span>;
};
